import React, { useState, useEffect, Fragment } from 'react';
import { Row, Collapse, Button, Card, CardBody } from 'reactstrap';
import { Colxx } from '../../../../../components/common/CustomBootstrap';
import '../components/css/property.scss';
// import MessageResponse from './components/ResponseBlock/MessageResponse';
// import LinkResponse from './components/ResponseBlock/LinkResponse';
// import ImageCarouselResponse from './components/ResponseBlock/ImageCarouselResponse';
import { RotateSpinner } from 'react-spinners-kit';
import ExampleResponse from '../components/ResponseBlock/ExampleResponse';
import { gAPI_QuestionSets } from '../../../../../constants/APIs';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { AxiosAPI, getGroupID } from '../../../../../helpers/AxiosAPI';
import QuestionSetForm from './components/QuestionSetForm';
import Question from './components/Question';
import QuestionSet from './components/QuestionSet';
import { faPlus, faBan } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import short from 'short-uuid';

function Index({ propertyId }) {
    const [responseData, setResponseData] = useState(null);
    const [isAddQuestionSet, setIsAddQuestionSet] = useState(false);

    const [result, setResult] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const loadResponse = async () => {
        setIsLoading(true);
        return await AxiosAPI({
            methed: 'get',
            url: `${gAPI_QuestionSets}/?propertyId=${propertyId}`,
        })
            .then(res => {
                setResult(res.data);
                setIsLoading(false);
            })
            .catch(err => {
                console.log(err);
            });
    };

    useEffect(() => {
        loadResponse();
    }, [propertyId]);

    useEffect(() => {
        setResponseData(result);
    }, [result]);

    const CancelQuestionSet = () => {
        setIsAddQuestionSet(false)
    }

    const generator = () => {
        return (
            <Fragment>
                <Row>
                    <Colxx xs="12" sm="12" md="9" lg="9" className="mb-4">
                        {result !== null && result.sets.length > 0 && (
                            <Fragment>
                                <Row>
                                    <Colxx xs="12" sm="3" md="3" lg="3" className="mb-4">
                                        <div
                                            onClick={() => {
                                                setIsAddQuestionSet(true);
                                            }}
                                        >
                                            <Button
                                                color="secondary"
                                                className="add-button"
                                                size="xs"
                                                style={{ width: '100%' }}
                                            >
                                                <FontAwesomeIcon icon={faPlus} />
                                                <span> </span>
                                                Add Question Series
                    </Button> </div>
                                    </Colxx>
                                </Row>
                                <Collapse isOpen={isAddQuestionSet}>
                                    <Colxx xxs="4" className="mb-2 p-4" style={{ border: 'solid 1px #4556ac' }}>
                                        <QuestionSetForm CancelQuestionSet={CancelQuestionSet}
                                            loadResponse={loadResponse}></QuestionSetForm>
                                    </Colxx>
                                </Collapse> </Fragment>)}

                        {result !== null && result.sets.length === 0 && (
                            <Fragment>
                                <Row>
                                    <Colxx xs="12" sm="4" md="4" lg="4" className="mb-4">
                                    </Colxx>
                                    <Colxx xs="12" sm="4" md="4" lg="4" className="mb-4">
                                        <Card className="mb-5 text-center">
                                            <CardBody>
                                                <Row>
                                                    <Colxx xxs="12" className="mb-4">
                                                        <div
                                                            className="content text-center">
                                                            <img
                                                                src={"https://bmbuiassetsprod.blob.core.windows.net/images/question.png"}
                                                                alt="example"
                                                                width="auto"
                                                                className="img-thumbnail"
                                                            />
                                                        </div>
                                                    </Colxx>
                                                </Row>
                                                <Row>
                                                    <Colxx xxs="12" className="mb-4">
                                                        <h2>Add Your First Set of Recommendation Questions</h2>
                                                        <p>Build a series of questions to help people filter the most relevant products & promotions for them</p>

                                                    </Colxx>
                                                </Row>
                                                <Row>
                                                    <Colxx xxs="12" className="mb-4">
                                                        <div
                                                            onClick={() => {
                                                                setIsAddQuestionSet(true);
                                                            }}
                                                        >
                                                            <Button
                                                                color="primary"
                                                                className="add-button"
                                                                style={{ width: '100%' }}
                                                            >
                                                                <FontAwesomeIcon icon={faPlus} />
                                                                <span> </span>
                        Add Question Series
                    </Button> </div>
                                                    </Colxx>
                                                </Row>
                                                <Collapse isOpen={isAddQuestionSet}>
                                                    <Colxx xxs="12" className="mb-2 p-4" style={{ border: 'solid 1px #4556ac' }}>
                                                        <QuestionSetForm CancelQuestionSet={CancelQuestionSet}
                                                            loadResponse={loadResponse}></QuestionSetForm>
                                                    </Colxx>
                                                </Collapse></CardBody>
                                        </Card>
                                    </Colxx>
                                    <Colxx xs="12" sm="4" md="4" lg="4" className="mb-4">
                                    </Colxx>
                                </Row>

                            </Fragment>)}


                        {result !== null && result.sets.map((set, index) => {
                            return (<QuestionSet set={set} index={index} loadResponse={loadResponse} />)
                        })}
                    </Colxx>
                    <Colxx xs="12" sm="12" md="3" lg="3" className="mb-4">
                        <div
                            className="content text-center" style={{ height: '100vh', position: 'fixed', overflow: 'auto' }} >
                            <img
                                src={"https://bmbuiassetsprod.blob.core.windows.net/images/recommender.png"}
                                alt="example"
                                width="auto"
                                className="img-thumbnail"
                            />
                        </div>
                    </Colxx>
                </Row>


            </Fragment>)
    }

    return (
        <Fragment>
            {isLoading ? (
                <Row>
                    <Colxx xxs="5" className="mb-2"></Colxx>
                    <Colxx xxs="2" className="mb-2">
                        <RotateSpinner size={60} color="#4556AC" loading={isLoading} />
                    </Colxx>
                    <Colxx xxs="5" className="mb-2"></Colxx>
                </Row>
            ) : (
                    generator()
                )}
        </Fragment>
    );
}
const mapStateToProps = ({ settings }) => {
    const { propertyId } = settings;
    return {
        propertyId,
    };
};

export default injectIntl(connect(mapStateToProps, {})(Index));